import { reactive } from 'vue'
import { isArray } from '@/global/utils/utils'

/**
 * The state behind an `ImagesPreviewDialog`, for the screens that open one by clicking a
 * picture.
 *
 * Three of them do - the photos beside a report's details, and the ones inside the popup
 * of a report's sign on either map - and each needs the same four things: whether the
 * dialog is open, which pictures it holds, which of them was clicked and what to call the
 * set. Kept here so the components are left with a click handler and a dialog tag.
 */
export function useImagesPreview () {
  const state = reactive({
    isOpen: false,
    images: [],
    initialIndex: 0,
    title: ''
  })

  /**
   * Opens the dialog on the clicked picture. `images` are taken as the dialog takes
   * them: plain urls, or objects carrying one.
   */
  const open = ({ images, index = 0, title = '' } = {}) => {
    const collected = (isArray(images) ? images : []).filter(Boolean)

    if (!collected.length) {
      return
    }

    state.images = collected
    state.initialIndex = Math.min(Math.max(index, 0), collected.length - 1)
    state.title = title
    state.isOpen = true
  }

  const close = () => {
    state.isOpen = false
  }

  return {
    state,
    open,
    close
  }
}
